import {CollapseProps} from 'antd/es/collapse/Collapse'

import {Collapse, SpoilersProps} from '@/src/shared/ui/collapse'

import * as UI from './collapseble-info.styled'

export const CollapseUI = UI

export const Collapsable = (props: CollapseProps & SpoilersProps) => {
  return (
    <UI.Component>
      <Collapse {...props} />
    </UI.Component>
  )
}
